import { Tables } from "@/types/supabase-types";

export type UOMLabelInfo = Pick<Tables<"UOM">, "name" | "abbreviation">;

/**
 * Displays a quantity with its unit of measure abbreviation, if available. If no unit of measure is available, it just
 * displays the unitless quantity.
 */
export const QuantityWithUOMAbbr: React.FC<{
  quantity: number;
  uom?: UOMLabelInfo;
}> = ({ quantity, uom }) =>
  uom ?
    <>
      {formatQuantity(quantity)} <abbr title={uom.name}>{uom.abbreviation}</abbr>
    </>
  : formatQuantity(quantity);

/**
 * Format an inventory quantity for display. This is a simple wrapper around `toLocaleString` that formats the number
 * with a maximum of 5 decimal places (matching the database precision).
 */
function formatQuantity(quantity: number) {
  return quantity.toLocaleString(undefined, { maximumFractionDigits: 5 });
}
